var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var FormChangeModel = /** @class */ (function () {
            function FormChangeModel() {
            }
            return FormChangeModel;
        }());
        controllers.FormChangeModel = FormChangeModel;
        var FormChangeModalController = /** @class */ (function (_super) {
            __extends(FormChangeModalController, _super);
            function FormChangeModalController($scope, formSection, form, processConfigId, formService, processConfigurationService, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.formService = formService;
                _this.processConfigurationService = processConfigurationService;
                _this.scope = $scope;
                _this.scope.form = form;
                _this.scope.formSection = formSection;
                _this.scope.processConfigId = processConfigId;
                _this.scope.destinationFormChanged = function () { return _this.destinationFormChanged(); };
                _this.scope.saveChanges = function () { return _this.saveChanges(); };
                _this.processConfigurationService.getExpandFields(_this.scope.processConfigId).then(function (processConfig) {
                    _this.scope.processConfiguration = processConfig;
                    _this.scope.forms = Enumerable.from(_this.scope.processConfiguration.myForms)
                        .where(function (i) { return i.formType === 4 /* MultiStep */ ||
                        i.formType === 5 /* SinglePage */; })
                        .toArray();
                });
                _this.scope.model = new FormChangeModel();
                return _this;
            }
            FormChangeModalController.prototype.destinationFormChanged = function () {
                if (this.scope.model.destinationForm === undefined || this.scope.model.destinationForm === null) {
                    this.scope.steps = [];
                }
                else {
                    this.scope.steps = this.scope.model.destinationForm.mySteps;
                }
            };
            FormChangeModalController.prototype.saveChanges = function () {
                var _this = this;
                if (this.scope.formSection !== null && this.scope.formSection !== undefined) {
                    // Dealing with a form section move
                    if (this.scope.model.destinationForm === undefined ||
                        this.scope.model.destinationForm === null ||
                        this.scope.model.destinationStep === undefined ||
                        this.scope.model.destinationStep === null) {
                        alert("Please select both a destination form and step if you wish to move this form section.");
                    }
                    else {
                        // Remove from old Form and Step
                        var currentStep = Enumerable.from(this.scope.form.mySteps)
                            .single(function (i) { return i.id === _this.scope.formSection.formStep_id; });
                        currentStep.formSections.remove(this.scope.formSection);
                        var orderedFormSections = Enumerable.from(currentStep.formSections)
                            .orderBy(function (i) { return i.position; })
                            .toArray();
                        for (var i = 0; i < orderedFormSections.length; i++) {
                            orderedFormSections[i].position = i;
                        }
                        // Add to new Form and Step
                        this.scope.model.destinationStep.formSections.push(this.scope.formSection);
                        this.scope.formSection.formStep_id = this.scope.model.destinationStep.id;
                        this.scope.formSection.position = this.scope.model.destinationStep.formSections.length - 1;
                        this.formService.saveAllChanges(function () {
                            _this.formService.setupFormSchema(_this.scope.form);
                            _this.formService.saveAllChanges(function () {
                                _this.formService.getFormConfiguration(_this.scope.model.destinationForm.id).then(function (form) {
                                    _this.formService.setupFormSchema(form);
                                    _this.formService.saveAllChanges(function () {
                                        var dto = {
                                            formSectionId: _this.scope.formSection.id,
                                            formSectionObjectSchemaId: _this.scope.formSection.objectSchema.id,
                                            originalFormId: _this.scope.form.id,
                                            newFormId: _this.scope.model.destinationForm.id
                                        };
                                        _this.formService.performFormChangeUpdates(dto);
                                        _this.dismissModal(true);
                                    });
                                });
                            });
                        });
                    }
                }
                else {
                    alert("This modal only supports moving a form section currently.");
                    this.dismissModal(true);
                }
            };
            return FormChangeModalController;
        }(controllers.BaseModalController));
        controllers.FormChangeModalController = FormChangeModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('FormChangeModalController', [
    '$scope', 'formSection', "form", 'processConfigId',
    'formService', "processConfigurationService", 'close'
]);
